import { validateOptionsList } from '../../../../utils';
import { DropdownInputDefinition } from '../../../../types';

// dropdown input validation
export default (input: DropdownInputDefinition, errors: string[]) => {
  const { options } = input;
  validateOptionsList(errors, options);
};
